export default {
  setWindowWidth: (state, width) => {
    state.windowWidth = width
  },

  setUserToken: (state, payload) => {
    state.user.token = payload
  },

  setUserGameId: (state, payload) => {
    state.user.playerResultId = payload
  },

  setUserDetails: (state, payload) => {
    state.user.details = payload
  },

  setTimeUp: (state, payload) => {
    state.timeUp = payload
  },

  setGameplay: (state, payload) => {
    state.gameplay = payload
  },

  setAssessment: (state, payload) => {
    state.assessment = payload
  },

  setAssessmentId: (state, payload) => {
    state.assessmentId = payload
  },

  setBarKey: (state, payload) => {
    state.barKey = payload
  },

  setAnswers: (state, payload) => {
    state.answers = payload
  },

  setAnswer: (state, payload) => {
    state.answers.push(payload)
  },

  startGame: state => {
    state.started = true
  },

  langKey: (state, payload) => {
    state.langKey = payload
  }
}
